import { LayoutComponentName } from '../types/layout'

export function detectLOB(pathname: string): LayoutComponentName | undefined {
  if (pathname.indexOf('/rp/life') === 0) {
    return 'Life'
  }
}
